module.exports = __webpack_public_path__ + "static/Group 469-2cf2c90f80a13d25cf51cad6cbc8fbb0.png";